export default "__VITE_ASSET__DlP5fUx7__"